import {
  getEmailRecommendedStaticVariantsSchema,
  gmailAnnotatedEmailRecommendedVariantSchema,
} from "@redotech/redo-model/email-product-recommendation";
import * as z from "zod/v4";

export const getEmailStaticVariantRecommendations = {
  name: "getEmailStaticVariantRecommendations" as const,
  input: getEmailRecommendedStaticVariantsSchema,
  output: z.array(gmailAnnotatedEmailRecommendedVariantSchema),
};
